//@ts-nocheck
import * as Cesium from "cesium";
import { getColourArray, truncateName } from "../../../../utils/commonFunctions";

const AOI_DATA_SOURCE_NAMES = ["Current_Order", "Executed_Order", "Pending_Order"];

export function ucp_visualization_presentation() {
    const getArrayCoordinates = (nestedArray) => {
        let resultArray = [];
        resultArray = resultArray.concat(...nestedArray);
        let finalArray = [];
        for (let i = 0; i < resultArray.length; i++) {
            finalArray.push(resultArray[i]);  // Push the current element
            if ((i % 2 === 1)) { // i >= 2 ensures we start from the 3rd element
                finalArray.push(0);  // Push 0 after every element at the specified odd index
            }
        }
        return finalArray;
    }

    function removeDataSourceByName(viewer, dataSourceName) {
        const dataSources = viewer.dataSources;  // Get the data sources collection
        if (!dataSources) return
        // Iterate over the data sources using a for loop
        for (let i = 0; i < dataSources.length; i++) {
            const dataSource = dataSources.get(i);  // Get the data source at index i
            // Check if the data source has a name that matches the one we're looking for
            if (dataSource.name === dataSourceName) {
                dataSources.remove(dataSource);
                return dataSource;  // Exit the function after removing
            }
        }
    }

    function getDataSourceByName(viewer, dataSourceName) {
        const dataSources = viewer.dataSources;  // Get the data sources collection
        // Iterate over the data sources using a for loop
        if (!dataSources) return
        for (let i = 0; i < dataSources.length; i++) {
            const dataSource = dataSources.get(i);  // Get the data source at index i

            if (dataSource.name === dataSourceName) {
                return dataSource;  // Return the removed data source
            }
        }
        return null;
    }

    const request_render = (viewer) => {
        if (!viewer) return
        try {
            viewer.scene.requestRender();
            setTimeout(() => {
                viewer.scene.requestRender();
            }, 100);
        } catch (error) {
            console.log('error', error);
        }
    }

    return {
        init_all_gs: (all_ground_stations, mm_viewer) => {
            let gsPacketList: any[] = [];
            all_ground_stations.forEach((gs_station) => {
                const packet = {
                    "billboard": {
                        "horizontalOrigin": Cesium.HorizontalOrigin.CENTER,  // Use Cesium constants
                        "image": '/assets/un_select_gs.svg',
                        "pixelOffset": new Cesium.Cartesian2(0, 0),          // Correctly use Cartesian2
                        "show": true,
                        "verticalOrigin": Cesium.VerticalOrigin.CENTER       // Use Cesium constants
                    },
                    "label": {
                        "fillColor": Cesium.Color.fromBytes(255, 255, 255, 255), // Correct RGBA to Cesium.Color
                        "font": "montserrat",
                        "horizontalOrigin": "LEFT",        // Use Cesium constants
                        "outlineColor": Cesium.Color.fromBytes(0, 0, 0, 255),    // Correct outline RGBA
                        "outlineWidth": 2,
                        "pixelOffset": {
                            "cartesian2": [
                                15,
                                0
                            ]
                        },
                        "show": false,
                        "style": "FILL_AND_OUTLINE",             // Use Cesium constants
                        "verticalOrigin": "CENTER",          // Use Cesium constants
                        "text": gs_station?.groundStationName ? gs_station?.groundStationName : gs_station?.name,
                    },
                    "description": "station",
                    "name": gs_station?.groundStationName ? gs_station?.groundStationName : gs_station?.name,
                    "position": {
                        "cartographicDegrees": [
                            gs_station?.properties?.longitude ? Number(gs_station?.properties?.longitude) : gs_station?.long,
                            gs_station?.properties?.latitude ? Number(gs_station?.properties?.latitude) : gs_station?.lat,
                            gs_station?.properties?.altitude ? Number(gs_station?.properties?.altitude) : 0
                        ]
                    },
                    "id": `gs_${gs_station?.groundStationId}`
                };
                gsPacketList.push(packet)
            })

            const dataSource = new Cesium.CzmlDataSource();
            removeDataSourceByName(mm_viewer, "GS_Object")

            mm_viewer && mm_viewer?.dataSources?.add(dataSource.load([
                {
                    "clock": {
                        "multiplier": 1,
                        "range": "CLAMPED",
                        "step": "SYSTEM_CLOCK_MULTIPLIER"
                    },
                    "id": "document",
                    "name": "GS_Object",
                    "version": "1.0"
                },
                ...gsPacketList
            ]))
        },
        highlightGroundStations: (ground_stations, mm_viewer) => {
            if (!mm_viewer) return
            try {
                const datasource: any = getDataSourceByName(mm_viewer, "GS_Object")
                if (datasource && datasource.entities && datasource.entities.values) {
                    for (const entity of datasource.entities.values) {
                        if (entity && entity.billboard && Cesium.defined(entity.billboard)) {
                            if (ground_stations.includes(entity.id)) {
                                entity.billboard.image = '/assets/select_gs.svg'
                            } else {
                                entity.billboard.image = '/assets/un_select_gs.svg';
                            }
                        }
                    }
                    request_render(mm_viewer);
                }
            } catch (error) {
                console.log(error);
            }
        },
        init_all_aois: (aois, ucp_viewer, dataSourceName) => {

            if (aois && ucp_viewer) {
                let aoisArray: any[] = []
                aois?.forEach((aoi, index) => {
                    if (aoi?.polygon) {
                        let coordinates = getArrayCoordinates(aoi.polygon[0]);
                        let packet = {
                            "description": "aoi",
                            "id": `aoi_${aoi?.areaOfInterestId}`,
                            "name": aoi?.name,
                            "polygon": {
                                "extrudedHeight": 0,
                                "height": 0,
                                "material": {
                                    "solidColor": {
                                        "color": {
                                            "rgba": aoi?.areaOfInterestId?.length > 5 ? [204, 245, 78, 50] : [255, 255, 255, 50]
                                        }
                                    }
                                },
                                "arcType": "RHUMB",
                                "positions": {
                                    "cartographicDegrees": coordinates
                                },
                            }

                        }
                        aoisArray.push(packet)
                    } else if (aoi?.point) {
                        const flattenedPoint = aoi?.point.flat(2)
                        let gtPacket = {
                            "billboard": {
                                "eyeOffset": {
                                    "cartesian": [
                                        0,
                                        0,
                                        10
                                    ]
                                },
                                "horizontalOrigin": "CENTER",
                                // Replace with a white dot
                                "image": "data:image/svg+xml;base64," + btoa(`
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                                    <circle cx="5" cy="5" r="5" fill="#F0F0F0" />
                                                </svg>`),
                                "pixelOffset": {
                                    "cartesian2": [
                                        0,
                                        0
                                    ]
                                },
                                "scale": 1,
                                "show": true,
                                "verticalOrigin": "CENTER"
                            },
                            "description": 'target',
                            "id": `aoi_${aoi?.areaOfInterestId}`,
                            "label": {
                                "fillColor": {
                                    "rgba": [
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                },
                                "font": "montserrat",
                                "horizontalOrigin": "LEFT",
                                "outlineColor": {
                                    "rgba": [
                                        0,
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                "outlineWidth": 2,
                                "pixelOffset": {
                                    "cartesian2": [
                                        12,
                                        0
                                    ]
                                },
                                "show": true,
                                "style": "FILL_AND_OUTLINE",
                                "verticalOrigin": "CENTER"
                            },
                            "name": aoi.name,
                            "position": {
                                "cartographicDegrees": [flattenedPoint?.[0], flattenedPoint?.[1], 0] // Longitude, Latitude, Height
                            }
                        };
                        aoisArray.push(gtPacket);
                    }
                })
                const dataSource = new Cesium.CzmlDataSource();
                removeDataSourceByName(ucp_viewer, dataSourceName)

                ucp_viewer && ucp_viewer.dataSources && ucp_viewer.dataSources.add(dataSource.load([
                    {
                        "id": "document",
                        "name": dataSourceName,
                        "version": "1.0"
                    },
                    ...aoisArray
                ]))
            }
        },
        highlightGroundTargets: (targets, viewer) => {
            if (!viewer) return
            try {
                const allDataSources = AOI_DATA_SOURCE_NAMES
                    .map(dataSourceName => getDataSourceByName(viewer, dataSourceName))
                    .filter(Boolean);
                allDataSources.forEach((dataSource) => {
                    dataSource?.entities?.values.forEach(entity => {
                        if (entity?.billboard) {
                            if (targets.includes(entity.id)) {
                                entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                                        <circle cx="5" cy="5" r="5" fill="rgb(142,125,238)"/>
                                    </svg>`);
                            } else {
                                entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                    <circle cx="5" cy="5" r="5" fill="rgb(240,240,240)" />
                                </svg>`);
                            }
                        }
                    });
                });
            } catch (error) {
                console.log(error);
            }
        },
        highlightCompletedAssignment: (ucp_viewer, dataSourceName, aois, hightlightColor) => {
            const useColor = hightlightColor || [204, 245, 78, 50]; // Default to green if no color is provided
            if (aois && ucp_viewer) {
                let aoisArray: any[] = []
                aois?.forEach((aoi, index) => {
                    if (aoi?.polygon) {
                        let coordinates = getArrayCoordinates(aoi.polygon[0]);
                        let packet = {
                            "description": "aoi",
                            "id": aoi?.areaOfInterestId,
                            "name": aoi?.name,
                            "polygon": {
                                "extrudedHeight": 0,
                                "height": 0,
                                "material": {
                                    "solidColor": {
                                        "color": {
                                            "rgba": useColor,
                                        }
                                    }
                                },
                                "arcType": "RHUMB",
                                "positions": {
                                    "cartographicDegrees": coordinates
                                }
                            }
                        }
                        aoisArray.push(packet)
                    } else if (aoi?.point) {
                        const flattenedPoint = aoi?.point.flat(2)
                        let gtPacket = {
                            "billboard": {
                                "eyeOffset": {
                                    "cartesian": [
                                        0,
                                        0,
                                        10
                                    ]
                                },
                                "horizontalOrigin": "CENTER",
                                // Replace with a red dot
                                "image": "data:image/svg+xml;base64," + btoa(`
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                                    <circle cx="5" cy="5" r="5" fill="#CCF54E" />
                                                </svg>`),
                                "pixelOffset": {
                                    "cartesian2": [
                                        0,
                                        0
                                    ]
                                },
                                "scale": 1,
                                "show": true,
                                "verticalOrigin": "CENTER"
                            },
                            "description": aoi?.name,
                            "id": aoi?.areaOfInterestId,
                            "label": {
                                "fillColor": {
                                    "rgba": [
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                },
                                "font": "montserrat",
                                "horizontalOrigin": "LEFT",
                                "outlineColor": {
                                    "rgba": [
                                        0,
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                "outlineWidth": 2,
                                "pixelOffset": {
                                    "cartesian2": [
                                        12,
                                        0
                                    ]
                                },
                                "show": true,
                                "style": "FILL_AND_OUTLINE",
                                "verticalOrigin": "CENTER"
                            },
                            "name": aoi.name,
                            "position": {
                                "cartographicDegrees": [flattenedPoint?.[0], flattenedPoint?.[1], 0] // Longitude, Latitude, Height
                            }
                        };
                        aoisArray.push(gtPacket);
                    }
                })
                const dataSource = new Cesium.CzmlDataSource();
                removeDataSourceByName(ucp_viewer, dataSourceName)
                if (!aoisArray.length || ucp_viewer) return
                ucp_viewer.dataSources.add(dataSource.load([
                    {
                        "id": "document",
                        "name": dataSourceName,
                        "version": "1.0"
                    },
                    ...aoisArray
                ]));
                request_render(ucp_viewer);
            }
        },

        remove_highlight_strip: (ucp_viewer, dataSourceName) => {
            removeDataSourceByName(ucp_viewer, dataSourceName);
            const camera = ucp_viewer.camera;
            const currentPosition = camera.positionCartographic;
            const newHeight = currentPosition.height + 4000000;
            ucp_viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromRadians(
                    currentPosition.longitude,
                    currentPosition.latitude,
                    newHeight
                ),
                duration: 2.0 // animation duration in seconds
            });

            request_render(ucp_viewer);
        },

        highlight_strip: (ucp_viewer, order, dataSourceName, highlightColor) => {
            if (ucp_viewer && order.strip && Object.keys(order.strip).length > 0) {
                const coordinates = getArrayCoordinates(order.strip.geoJSON.coordinates[0]);
                removeDataSourceByName(ucp_viewer, dataSourceName);
                let packet;
                if (order?.['strip']?.['geoJSON']?.['type'] === 'Point') {
                    const flattenedPoint = order?.['strip']?.['geoJSON']?.['coordinates'].flat(2)
                    packet =
                        [{
                            "id": "document",
                            "name": dataSourceName,
                            "version": "1.0"
                        },
                        {
                            "billboard": {
                                "eyeOffset": {
                                    "cartesian": [
                                        0,
                                        0,
                                        -10
                                    ]
                                },
                                "horizontalOrigin": "CENTER",
                                // Replace with a green or grey dot as per status
                                // 204, 245, 78, 255 is highlight green hex: 00FF00
                                // HEX: 808080 is gray when not captured
                                "image": JSON.stringify(highlightColor) === JSON.stringify([204, 245, 78, 255]) ? "data:image/svg+xml;base64," + btoa(`
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                         <circle cx="5" cy="5" r="5" fill="#00FF00" />
                                    </svg>`) : "data:image/svg+xml;base64," + btoa(`
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                        <circle cx="5" cy="5" r="5" fill="#808080" />
                                    </svg>`),
                                "pixelOffset": {
                                    "cartesian2": [
                                        0,
                                        0
                                    ]
                                },
                                "scale": 1,
                                "show": true,
                                "verticalOrigin": "CENTER"
                            },
                            "description": order?.name,
                            "id": order?.name,
                            "label": {
                                "fillColor": {
                                    "rgba": [
                                        255,
                                        255,
                                        255,
                                        255
                                    ]
                                },
                                "font": "montserrat",
                                "horizontalOrigin": "LEFT",
                                "outlineColor": {
                                    "rgba": [
                                        0,
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                "outlineWidth": 2,
                                "pixelOffset": {
                                    "cartesian2": [
                                        12,
                                        0
                                    ]
                                },
                                "show": true,
                                "style": "FILL_AND_OUTLINE",
                                "verticalOrigin": "CENTER"
                            },
                            "name": order.name,
                            "position": {
                                "cartographicDegrees": [flattenedPoint?.[0], flattenedPoint?.[1], 0] // Longitude, Latitude, Height
                            }
                        }]
                } else {
                    packet = [
                        {
                            "id": "document",
                            "name": dataSourceName,
                            "version": "1.0"
                        },
                        {
                            "description": "aoi",
                            "id": order.name,
                            "name": order.name,
                            "polygon": {
                                "extrudedHeight": 1.0,
                                "height": 1.0,
                                "material": {
                                    "solidColor": {
                                        "color": {
                                            "rgba": highlightColor,
                                        }
                                    }
                                },
                                "arcType": "RHUMB",
                                "positions": {
                                    "cartographicDegrees": coordinates
                                }
                            }
                        }
                    ]
                }

                const dataSource = new Cesium.CzmlDataSource();
                ucp_viewer && ucp_viewer.dataSources &&
                    Object.keys(ucp_viewer.dataSources).length > 0
                    && dataSource.load(packet).then(() => {
                        ucp_viewer.dataSources.add(dataSource);
                        ucp_viewer.zoomTo(
                            dataSource,
                            new Cesium.HeadingPitchRange(0, -1.0, 5000000),
                            {
                                duration: 2.5 // seconds for smooth zoom
                            }
                        );
                    }).catch((error) => {
                        console.error("Error loading packet:", error);
                    });
                request_render(ucp_viewer);
            }
        },
        highlight_aois: (orders, ucp_viewer) => {
            if (orders && ucp_viewer) {
                const highlightedOrderIds = new Set(orders.map(order => order?.spec?.geofeature?.features?.[0]?.id))

                const allDataSources = AOI_DATA_SOURCE_NAMES
                    .map(dataSourceName => getDataSourceByName(ucp_viewer, dataSourceName))
                    .filter(Boolean);

                allDataSources.forEach((dataSource) => {
                    dataSource?.entities?.values.forEach(entity => {
                        const shouldShow = highlightedOrderIds.has(entity?.id);
                        entity.show = shouldShow;

                        if (shouldShow) {
                            if (entity?.polygon) {
                                entity.polygon.material = new Cesium.ColorMaterialProperty(Cesium.Color.fromBytes(142, 125, 238, 100))
                            }

                            if (entity?.billboard) {
                                entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                                        <circle cx="5" cy="5" r="5" fill="rgb(142,125,238)"/>
                                    </svg>`);
                            }
                        }
                    })
                })
                request_render(ucp_viewer);
            }
        },
        reset_all_aois_visibility: (ucp_viewer) => {
            AOI_DATA_SOURCE_NAMES.forEach((dataSourceName) => {
                const dataSource = getDataSourceByName(ucp_viewer, dataSourceName);

                if (dataSource && dataSource.entities?.values?.length > 0) {
                    for (const entity of dataSource.entities.values) {
                        entity.show = true;

                        if (entity?.polygon) {
                            entity.polygon.material = new Cesium.ColorMaterialProperty(
                                Cesium.Color.fromBytes(204, 245, 78, 50)
                            );
                        }

                        if (entity?.billboard) {
                            entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                                    <circle cx="5" cy="5" r="5" fill="rgb(240,240,240)" />
                                </svg>`);
                        }
                    }
                }
            });

            request_render(ucp_viewer);
        },
        init_all_satellites: (allOrbitData, mm_viewer, scenarioCurrentTime) => {
            const satGroup = allOrbitData?.satellites;
            if (satGroup) {
                let satelliteData: any[] = [];
                satGroup.forEach(sat => {
                    sat?.satelliteGroups?.flatMap(singleSat => {
                        singleSat?.visualizationData?.satellites?.forEach(satellite => {
                            const colorString = satellite.color;
                            const colorArray = getColourArray(colorString);
                            const packet = {
                                availability: satellite?.availability,
                                billboard: {
                                    eyeOffset: { cartesian: [0, 0, 0] },
                                    horizontalOrigin: "CENTER",
                                    image: '/assets/selectedSatellite.png',
                                    pixelOffset: { cartesian2: [0, 0] },
                                    scale: 0.75,
                                    show: true,
                                    verticalOrigin: "CENTER"
                                },
                                description: "Attached Object to satellite",
                                id: `oo_${satellite?.satId}`,
                                path: {
                                    leadTime: [{ number: 5000 }],
                                    width: 1,
                                    material: {
                                        solidColor: {
                                            color: {
                                                rgba: [colorArray[0], colorArray[1], colorArray[2], 255]
                                            }
                                        }
                                    },
                                    resolution: 10,
                                    show: [{ boolean: true, interval: satellite?.availability }],
                                    trailTime: [{ number: 5000 }]
                                },
                                position: {
                                    cartographicDegrees: satellite?.satOrbitPoint,
                                    epoch: satellite?.availability?.split('/')[0]
                                },
                                label: {
                                    fillColor: Cesium.Color.fromBytes(255, 255, 255, 255),
                                    font: 'montserrat',
                                    horizontalOrigin: 'LEFT',
                                    outlineColor: Cesium.Color.fromBytes(0, 0, 0, 255),
                                    outlineWidth: 2,
                                    pixelOffset: {
                                        cartesian2: [
                                            10,
                                            0
                                        ]
                                    },
                                    show: false,
                                    style: 'FILL_AND_OUTLINE',
                                    verticalOrigin: 'CENTER',
                                    text: truncateName(satellite?.satName),
                                },
                            };

                            satelliteData.push(packet);
                        });
                    });
                });

                removeDataSourceByName(mm_viewer, "Orbit_Object");
                const dataSource = new Cesium.CzmlDataSource();
                mm_viewer?.dataSources?.add(dataSource.load([
                    {
                        clock: {
                            ...(scenarioCurrentTime && { currentTime: scenarioCurrentTime }),
                            interval: allOrbitData?.documentMetadata?.clock?.interval,
                            multiplier: 1,
                            range: "CLAMPED",
                            step: "SYSTEM_CLOCK_MULTIPLIER"
                        },
                        id: "document",
                        name: "Orbit_Object",
                        version: "1.0"
                    },
                    ...satelliteData
                ]));

                request_render(mm_viewer);
            }
        },
        selected_satellite: (satelliteId, mm_viewer) => {
            if (!mm_viewer) return;
            try {
                const datasource = getDataSourceByName(mm_viewer, 'Orbit_Object')
                if (datasource && datasource.entities && datasource.entities.values) {
                    for (const entity of datasource.entities.values) {
                        if (entity.id === satelliteId && Cesium.defined(entity.label) && Cesium.defined(entity.billboard) && Cesium.defined(entity.path)) {
                            entity.path.material = new Cesium.ColorMaterialProperty(Cesium.Color.fromBytes(0, 245, 0, 240)); // orbit highlight color
                            entity.label.show = true;
                        }
                    }
                    request_render(mm_viewer);
                }
            } catch (error) {
                console.log(error);
            }
        },
        unselect_satellites: (mm_viewer, allOrbitData) => {
            if (!mm_viewer) return;
            try {
                const dataSource = getDataSourceByName(mm_viewer, "Orbit_Object");
                const satGroup = allOrbitData?.satellites;
                if (satGroup) {
                    satGroup.forEach(sat => {
                        sat?.satelliteGroups?.flatMap(singleSat => {
                            singleSat?.visualizationData?.satellites?.forEach(satellite => {
                                const colorString = satellite.color;
                                const colorArray = getColourArray(colorString);
                                const entity = dataSource.entities.getById(`oo_${satellite.satId}`);
                                if (!entity) return
                                entity.path.material = new Cesium.ColorMaterialProperty(Cesium.Color.fromBytes(colorArray[0], colorArray[1], colorArray[2], 255)); // orbit default color
                                entity.label.show = false;
                            });
                        });
                    });
                    request_render(mm_viewer);
                }
            } catch (error) {
                console.log(error);
            }
        },
        remove_entity_by_id: (entityId, dataSourceName, mm_viewer) => {
            const dataSource = getDataSourceByName(mm_viewer, dataSourceName)
            if (!dataSource) return
            const entity = dataSource.entities.getById(entityId);
            dataSource.entities.remove(entity)
        },
        hide_datasource: (ucp_viewer, dataSourceName) => {
            const dataSource = getDataSourceByName(ucp_viewer, dataSourceName);
            if (!dataSource) return
            dataSource.show = false;
            request_render(ucp_viewer);
        },
        show_datasource: (ucp_viewer, dataSourceName) => {
            const dataSource = getDataSourceByName(ucp_viewer, dataSourceName);
            if (!dataSource) return
            dataSource.show = true;
            request_render(ucp_viewer);
        },
        zoom_into_selected_entity: (ucp_viewer, dataSourceName, entityId) => {
            const dataSource = getDataSourceByName(ucp_viewer, dataSourceName);
            if (!dataSource) return

            const entity = dataSource.entities.getById(entityId);
            const currentColor = entity?.polygon?.material?.color?.getValue?.(Cesium.JulianDate.now());
            const highlightColor = Cesium.Color.fromBytes(142, 125, 238, 100);

            const julianDate = Cesium.JulianDate.now();
            let targetPositionArray = null;

            if (entity?.polygon) {
                if (!Cesium.Color.equals(currentColor, highlightColor)) {
                    entity.polygon.material = new Cesium.ColorMaterialProperty(highlightColor);
                }
                const hierarchy = entity.polygon.hierarchy?.getValue(julianDate);
                if (hierarchy?.positions?.length) {
                    targetPositionArray = hierarchy.positions;
                }
            }

            if (entity?.billboard) {
                entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                            <circle cx="5" cy="5" r="5" fill="rgb(142,125,238)" />
                        </svg>
                    `);
                if (entity?.position) {
                    const position = entity?.position.getValue(julianDate);
                    if (position) {
                        targetPositionArray = [position];
                    }
                }
            }

            // commented the zooming for now, it may use in future
            // if (targetPositionArray?.length) {
            //     const boundingSphere = Cesium.BoundingSphere.fromPoints(targetPositionArray);
            //     ucp_viewer.camera.flyToBoundingSphere(boundingSphere, {
            //         duration: 2,
            //         offset: new Cesium.HeadingPitchRange(0, -0.5, entity.billboard ? 4000000 : boundingSphere.radius * 5.0),
            //     });
            // } else {
            //     console.warn("No valid geometry found for entity", entity);
            // }

            request_render(ucp_viewer);
        },
        refresh_aoi_view: (ucp_viewer, dataSourceName) => {
            const dataSource = getDataSourceByName(ucp_viewer, dataSourceName)
            if (!dataSource) return

            dataSource.entities.values.forEach(entity => {
                const currentColor = entity?.polygon?.material?.color?.getValue?.(Cesium.JulianDate.now());
                const newColor = entity?._id?.length > 5 ? Cesium.Color.fromBytes(204, 245, 78, 50) : Cesium.Color.fromBytes(255, 255, 255, 50);

                if (Cesium.defined(entity) && Cesium.defined(entity.polygon) && !Cesium.Color.equals(currentColor, newColor)) {
                    entity.polygon.material = new Cesium.ColorMaterialProperty(newColor);
                }

                if (Cesium.defined(entity) && Cesium.defined(entity.billboard)) {
                    entity.billboard.image = 'data:image/svg+xml;base64,' + btoa(`
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                            <circle cx="5" cy="5" r="5" fill="rgb(240,240,240)" />
                        </svg>
                    `);
                }
                request_render(ucp_viewer);
            });
        }
    }
}